export class BaseFeatureTogglesProvider {
    constructor(namespace) {
        this.featureToggles = [];
        this.namespace = namespace;
    }
    getNamespace() {
        return this.namespace;
    }
    async refresh() {
        try {
            if (this.refreshRequestedCallback) {
                await this.refreshRequestedCallback(this.getNamespace());
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    onRefreshRequested(callback) {
        this.refreshRequestedCallback = callback;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmFzZS1mZWF0dXJlLXRvZ2dsZXMucHJvdmlkZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvc2hhcmVkL2ZlYXR1cmUtdG9nZ2xlcy9wcm92aWRlcnMvYmFzZS1mZWF0dXJlLXRvZ2dsZXMucHJvdmlkZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBU0EsTUFBTSxPQUFnQiwwQkFBMEI7SUFNNUMsWUFBc0IsU0FBaUI7UUFGN0IsbUJBQWMsR0FBb0IsRUFBRSxDQUFDO1FBRzNDLElBQUksQ0FBQyxTQUFTLEdBQUcsU0FBUyxDQUFDO0lBQy9CLENBQUM7SUFFTSxZQUFZO1FBQ2YsT0FBTyxJQUFJLENBQUMsU0FBUyxDQUFDO0lBQzFCLENBQUM7SUFJTSxLQUFLLENBQUMsT0FBTztRQUNoQixJQUFJO1lBQ0EsSUFBSSxJQUFJLENBQUMsd0JBQXdCLEVBQUU7Z0JBQy9CLE1BQU0sSUFBSSxDQUFDLHdCQUF3QixDQUFDLElBQUksQ0FBQyxZQUFZLEVBQUUsQ0FBQyxDQUFDO2FBQzVEO1NBQ0o7UUFBQyxPQUFPLENBQUMsRUFBRTtZQUNSLE9BQU8sQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUM7U0FDcEI7SUFDTCxDQUFDO0lBRU0sa0JBQWtCLENBQUMsUUFBcUQ7UUFDM0UsSUFBSSxDQUFDLHdCQUF3QixHQUFHLFFBQVEsQ0FBQztJQUM3QyxDQUFDO0NBQ0oifQ==